import { call, put, takeLatest } from "redux-saga/effects";
import axiosInstance from "../../../axios/axiosInstance";
import { notify } from "../../../utils/notification";
import {logOut} from '../../../utils/helpers/logout'
import apiEndpoints from "../../../axios/api";
import { GET_THERAPIST_LIST_FALIURE, GET_THERAPIST_LIST_SUCCESS, GET_THERAPIST_LIST, DOWNLOAD_RECOMMENDATIONS_EXCEL_SUCCESS, DOWNLOAD_RECOMMENDATIONS_EXCEL_FALIURE, DOWNLOAD_RECOMMENDATIONS_EXCEL, GET_RECOMMENDATIONS, GET_RECOMMENDATIONS_FALIURE, GET_RECOMMENDATIONS_SUCCESS } from "../../constants";
import { logger } from "../../../utils/logging";


export const getTherapistListReq = async({data})=>{   

    return axiosInstance.get(`${apiEndpoints.GET_THERAPIST_LIST_API}?${data.date ? `&filter_date=${data.date}`: ''}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getTherapistList({data}){
    try{
        let result = yield call(getTherapistListReq, {data})
        if(result.statusCode === 200){
            yield put({ type: GET_THERAPIST_LIST_SUCCESS, payload: result.data});  
        }else{
            yield put({ type: GET_THERAPIST_LIST_FALIURE});
        }
    }catch(error){
        yield put({ type: GET_THERAPIST_LIST_FALIURE, message: error.message });
        logger.log(error)

    }
}

export const downloadRecommendationsExcelReq = async({data})=>{   

    return axiosInstance.get(`${apiEndpoints.DOWNLOAD_RECOMMENDATIONS_EXCEL_API}?${data.searchText ? `&filter_text=${data.searchText}`: ''}${data.therapistName ? `&filter_therapist=${data.therapistName}`: ''}${data.date ? `&filter_date=${data.date}`: ''}${data.orderBy ? `&order_by=${data.orderBy}`: ''}${data.order ? `&order_by_type=${data.order}`: ''}`, {
        responseType: 'arraybuffer',
    })
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* downloadRecommendationsExcel({data}){
    try{
        let result = yield call(downloadRecommendationsExcelReq, {data})
        if(result.data instanceof ArrayBuffer){
            yield put({ type: DOWNLOAD_RECOMMENDATIONS_EXCEL_SUCCESS, payload: result.data});  
            data?.onSuccessCallback(result.data)
        } else{
            yield put({ type: DOWNLOAD_RECOMMENDATIONS_EXCEL_FALIURE,});  
        }        
    }catch(error){
        yield put({ type: DOWNLOAD_RECOMMENDATIONS_EXCEL_FALIURE, message: error.message });
        logger.log(error)

    }
}



export const getRecommendationsReq = async({data})=>{   

    return axiosInstance.get(`${apiEndpoints.GET_RECOMMENDATIONS_API}?page=${data.page}&limit=${data.pageLimit}${data.searchText ? `&filter_text=${data.searchText}`: ''}${data.therapistName ? `&filter_therapist=${data.therapistName}`: ''}${data.date ? `&filter_date=${data.date}`: ''}${data.orderBy ? `&order_by=${data.orderBy}`: ''}${data.order ? `&order_by_type=${data.order}`: ''}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);

            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getRecommendations({data}){
    try{
        let result = yield call(getRecommendationsReq, {data})
        if(result.statusCode === 200){
            yield put({ type: GET_RECOMMENDATIONS_SUCCESS, payload: result.data});  
        }  else{
            yield put({ type: GET_RECOMMENDATIONS_FALIURE});  
        }        
    }catch(error){
        yield put({ type: GET_RECOMMENDATIONS_FALIURE, message: error.message });
        logger.log(error)

    }
}



function* RecommendationsSaga(){
    yield takeLatest(GET_THERAPIST_LIST, getTherapistList)
    yield takeLatest(DOWNLOAD_RECOMMENDATIONS_EXCEL, downloadRecommendationsExcel)
    yield takeLatest(GET_RECOMMENDATIONS, getRecommendations)
}

export default RecommendationsSaga;